//结算中心的tab
global.constants = {
    activePrepayTab: '',
};